module.exports = __webpack_public_path__ + "img/instyle-plus-back.6544dd9c.png";